import { FeatureFlagName, STORAGE_KEY } from './useFeatureFlags'

const readPersistedFlags = (): Record<string, unknown> | undefined => {
  try {
    const featureFlags = localStorage.getItem(STORAGE_KEY)

    if (!featureFlags) {
      return undefined
    }

    const parsed = JSON.parse(featureFlags)

    // Handle the nested structure: {state: {flags: {...}}, version: 0}
    return parsed.state?.flags || parsed
  } catch (_error) {
    // Silently fail - feature flag check failed
  }

  return undefined
}

/**
 * True/false only when the user has actually set the flag. `undefined` means it
 * was never controlled — callers must not coerce that to `false`.
 */
export const getFeatureFlagOverride = (flagName: FeatureFlagName): boolean | undefined => {
  const flags = readPersistedFlags()

  if (!flags || !Object.prototype.hasOwnProperty.call(flags, flagName)) {
    return undefined
  }

  if (flags[flagName] === true) {
    return true
  }

  if (flags[flagName] === false) {
    return false
  }

  return undefined
}

/**
 * Reusable feature flag check function that can be used outside of React components
 * This function checks localStorage directly to avoid hook usage restrictions
 */
export const hasFeatureFlag = (flagName: FeatureFlagName): boolean => {
  return getFeatureFlagOverride(flagName) === true
}
